import hide from './hide';
import loadRelatedProducts from './loadRelatedProducts';
import put from './put';
import remove from './remove';
import unhide from './unhide';
import update from './update';
import sendDerelictCart from './sendDerelictCart';
import sendPromocode from './sendPromocode';
import sendCheckerPromocode from './sendCheckerPromocode';
import sendBonus from './sendBonus';
import updatePosition from './updatePosition';
import cart from './cart';
import success from './success';
import checkCertificate from './checkCertificate';
import removeCertificate from './removeCertificate';
import getRelatedProducts from './getRelatedProducts';

export default {
  success,
  cart,
  hide,
  loadRelatedProducts,
  put,
  remove,
  unhide,
  update,
  sendBonus,
  sendDerelictCart,
  sendPromocode,
  updatePosition,
  sendCheckerPromocode,
  checkCertificate,
  removeCertificate,
  getRelatedProducts,
};
